// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/file-text.js';

import { paths } from '../generated/file-text';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('file-text', Original, paths);
